import { v4 } from 'uuid'

const generateId = (id: string) => (process.env.NODE_ENV === 'production' ? v4() : id)

export default generateId
